<!--下单记录-->
<template>
    <div class="container">
        <div class="handleBox flex flex-c flex-b">
            <p class="navTitle">下单记录管理 ></p>
            <el-input placeholder="姓名/联系方式/物流单号" v-model="search.selectValue" clearable @clear="curr=1;getList()" size="small" class="input-with-select" style="width:300px">
                <el-button slot="append" icon="el-icon-search" @click="curr=1;getList()"></el-button>
            </el-input>
            <el-button type="primary" icon="el-icon-download" size="small" @click="daochuOrder">导出订单</el-button>
        </div>
        <!-- 第二行 表格操作栏 -->
        <div class="selectBar" style="margin-bottom: 10px;">
            <div style="overflow:hidden">
                <label>支付方式：</label>
                <el-select v-model="search.pay_id" clearable placeholder="支付方式" @change="curr=1;getList()" style="width: 11%;margin-right: 10px;">
                    <el-option v-for="(item,index) in payList" :label="item.name" :value="item.name" :key="index"></el-option>
                </el-select>

                <label>送货方式：</label>
                <el-select v-model="search.delivery_id" clearable placeholder="送货方式" @change="curr=1;getList()" style="width: 11%;margin-right: 10px;">
                    <el-option v-for="(item,index) in deliveryList" :label="item.name" :value="item.name" :key="index"></el-option>
                </el-select>

                <label>地址：</label>
                <el-select v-model="address.pname" @change="choseProvince" clearable  @clear="search.selectPCode = ''" class="pca" placeholder="省" style="width: 12%;">
                    <el-option v-for="(item,index) in address.province" :key="index" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>  
                <el-select v-model="address.cname" @change="choseCity" clearable @clear="search.selectCCode = ''" class="pca" placeholder="市" style="width: 12%;">
                    <el-option v-for="(item,index) in address.city" :key="index" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
                <el-select v-model="address.bname" @change="choseBlock" @clear="search.selectACode = ''" clearable class="pca" placeholder="区" style="width: 12%;">
                    <el-option v-for="(item,index) in address.area" :key="index" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>

                <label for="" style="margin-left: 5px;">时间： </label>
                <el-date-picker v-model="selectMonth" style="width: 16%;" value-format="yyyy-MM-dd" type="daterange" @change="curr=1;getList()" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间">
                </el-date-picker>
            
            </div>
        </div>

        <!--tab切换-->
        <!-- <el-menu default-active="1" class="el-menu-demo" mode="horizontal" stretch @select="handleSelect" style="padding: 0 15px;">
            <el-menu-item index="1" style="width: 50%;text-align: center;">当日下单记录</el-menu-item>
            <el-menu-item index="2" style="width: 50%;text-align: center;">本月下单记录</el-menu-item>
        </el-menu> -->

        <div class="table" style="height:calc( 100% - 140px );margin-top:0px">
            <el-table :data="list" border :header-cell-style="{background:'#fafdff',color:'#606266',fontWeight:'normal'}" height="calc( 100% - 120px )">
                <el-table-column width="140" prop="num"  label="订单编号" show-overflow-tooltip></el-table-column>
                <el-table-column width="140" prop="order_number"  label="物流单号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="user_name" label="销售人员" width="80" show-overflow-tooltip></el-table-column>
                <el-table-column prop="sender_name" width="100" label="寄件人姓名" show-overflow-tooltip></el-table-column>
                <el-table-column width="100" prop="sender_mobile" label="寄件人联系方式" show-overflow-tooltip></el-table-column>
                <el-table-column width="120" prop="sender_company_name" label="寄件人公司名称" show-overflow-tooltip></el-table-column>
                <el-table-column width="170" prop="sender_address_name" label="寄件人地址" show-overflow-tooltip></el-table-column>
                <el-table-column prop="recipient_name"  width="100" label="收件人姓名" show-overflow-tooltip></el-table-column>
                <el-table-column width="120" prop="recipient_mobile" label="收件人联系方式" show-overflow-tooltip></el-table-column>
                <el-table-column width="170" prop="recipient_address_name" label="收件人地址" show-overflow-tooltip></el-table-column>
                <el-table-column width="100" prop="collection" align="center" label="代收货款" show-overflow-tooltip></el-table-column>
                <el-table-column  width="100" prop="payment_type" align="center" label="支付方式" show-overflow-tooltip></el-table-column>
                <el-table-column  width="100" prop="delivery_type" align="center" label="送货方式" show-overflow-tooltip></el-table-column>
                <el-table-column width="80" prop="cancel_name" align="center" label="订单状态" show-overflow-tooltip></el-table-column>
                <el-table-column width="100" prop="remark" align="center" label="备注" show-overflow-tooltip></el-table-column>
                <el-table-column width="160" align="center" prop="create_time" label="创建时间" show-overflow-tooltip></el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="paging">
                <el-pagination @current-change="currChange" @size-change="sizeChange" :current-page="curr" :page-size="row" background layout="total, sizes, prev, pager, next, jumper" :total="count">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    import cityData from "../assets/js/city.data.js"
    export default {
        name: 'Home',
        data: function () {
            return {
                curr: 1,
                row: 10,
                count: 0,
                pages: 1, //总页数
                menu: 1,
                
                citydata: [],   //省市区
                list: [],   //订单列表
                payList: [],   //支付方式列表
                deliveryList:[], //送货方式列表
                selectMonth: '',
                search:{
                    selectValue: '',
                    selectPCode: '',
                    selectCCode: '',
                    selectACode: '',
                    pay_id:'',
                    delivery_id:''
                },
                address: {
                    province: [],
                    city: [],
                    area: [],
                    pname: '',//省的名字
                    cname: '',//市的名字
                    bname: '',  //区的名字
                    shi1: [],
                    qu1: [],
                },
                
                
            }
        },
        mounted: function () {
            var area = localStorage.getItem('area')
            this.citydata = JSON.parse(area)
            this.getList(1)
            this.getPay()
            this.getDelivery()
            this.init()
        },
        methods: {
            init: function () {
                var _this = this
                // this.citydata = cityData.cityData3
                this.citydata.forEach(function (item, index) {
                    _this.address.province.push({ id: item.value, name: item.label, children: item.children })
                    if (_this.address.pname) {
                        item.children.forEach(city => {
                            _this.address.city.push({ id: city.value, name: city.label, children: city.children })
                        })
                    }
                })
            },
            getList: function (tab) {
                this.http.post('/order/getList', {
                    row: this.row,
                    curr: this.curr,
                    // time: tab == 1 ? 'today' : 'month',
                    time:'all',
                    search:this.search.selectValue,
                    payment_type:this.search.pay_id,
                    delivery_type:this.search.delivery_id,
                    address: this.search.selectPCode && !this.search.selectCCode && !this.search.selectACode ? this.search.selectPCode : this.search.selectPCode && this.search.selectCCode && !this.search.selectACode ? this.search.selectCCode : this.search.selectACode,
                    start_time: this.selectMonth ? this.selectMonth[0] : '',
                    end_time: this.selectMonth ? this.selectMonth[1] : ''
                }).then(res => {
                    this.list = res.list
                    this.curr = res.curr;
                    this.pages = res.pages;
                    this.count = res.count;
                    // for(var i in res.list){
                    //      var timearr = res.list[i].create_time.replace(" ", ":").replace(/\:/g, "-").split("-");                  
                    //      res.list[i].create_time = timearr[0] + "-" + Number(timearr[1]) + "-" + timearr[2]
                    // }
                })
            },
            daochuOrder:function(){
                console.log(this.selectMonth)
                // var api = '/order/export?params={"start_time":' + this.selectMonth ? this.selectMonth[0] : '' + '}';
                // var api = '/order/export?params={"start_time":'+ this.selectMonth[0] +',"end_time":'+ this.selectMonth[1] +' }'
                var startTime = this.selectMonth ? this.selectMonth[0] : ''
                var endTime = this.selectMonth ? this.selectMonth[1] : ''
                var address = this.search.selectPCode && !this.search.selectCCode && !this.search.selectACode ? this.search.selectPCode : this.search.selectPCode && this.search.selectCCode && !this.search.selectACode ? this.search.selectCCode : this.search.selectACode
                var api = "/order/export?start_time=" + startTime  + '&end_time='+ endTime +'&payment_type='+ this.search.pay_id +'&delivery_type='+this.search.delivery_id + '&search='+ this.search.selectValue+'&address='+ address
                var url = this.domain + api;
                console.log(url)
                location.href = url;
                this.getList();
            },
            //支付方式列表
            getPay:function(){
                this.http.post('/setting/getList',{
                    curr:1,
                    row:1000,
                    type:'payment_method'
                }).then(res=>{
                    this.payList = res.list
                })
            },

            //送货方式列表
            getDelivery: function () {
                this.http.post('/setting/getList', {
                    curr: 1,
                    row: 1000,
                    type: 'delivery_method'
                }).then(res => {
                    this.deliveryList = res.list
                })
            },
            //选择省
            choseProvince: function (e) {
                let that = this;
                that.address.city = [];   //清除市级所有数据
                that.address.area = [];	  //清除区域所有数据
                that.address.cname = '';
                that.address.bname = '';
                that.search.selectPCode = e
                for (var index2 in that.address.province) {
                    if (e === that.address.province[index2].id) {
                        that.address.shi1 = that.address.province[index2].children
                        that.address.pname = that.address.province[index2].name
                        that.address.shi1.forEach(function (citem, cindex) {
                            that.address.city.push({ id: citem.value, name: citem.label, children: citem.children })
                        })
                    }
                }
                this.curr = 1
                this.getList()
            },

            //选市
            choseCity: function (e) {
                let that = this;
                that.address.area = [];
                that.address.bname = ''
                that.search.selectCCode = e
                if (that.address.pname == '') {
                    that.address.province = [];
                }
                for (var index3 in that.address.city) {
                    if (e === that.address.city[index3].id) {
                        that.address.qu1 = that.address.city[index3].children
                        that.address.cname = that.address.city[index3].name
                        that.address.qu1.forEach(function (bitem, bindex) {
                            that.address.area.push({ id: bitem.value, name: bitem.label, children: [] })
                        })
                    }
                }
                this.curr = 1
                this.getList()
            },

            // 选区
            choseBlock: function (e) {
                let that = this;
                that.search.selectACode = e
                for (var index4 in that.address.area) {
                    if (e === that.address.area[index4].id) {
                        that.address.bname = that.address.area[index4].name
                    }
                }
                this.curr = 1
                this.getList()
            },

            //切换tab
            handleSelect(key, keyPath) {
                this.menu = key;
                this.getList(key)
            },

            currChange: function (curr) {
                this.curr = curr;
                this.getList()
            },
            sizeChange: function (row) {
                this.row = row;
                this.getList()
            },
        }
    }
</script>